(()=>{
  if(window.tbDraftNavigationBound)return;
  window.tbDraftNavigationBound=true;
  const menus=()=>[...document.querySelectorAll('.tbmm-desktop-menu')];
  const drawer=id=>document.getElementById(id);
  const open=d=>d&&(d.classList.contains('drawer--is-open')||d.classList.contains('is-open')||d.getAttribute('aria-hidden')==='false');
  const closeDrawer=d=>{if(open(d))d.querySelector('.js-drawer-close')?.click()};
  const closeMenus=except=>menus().forEach(m=>{if(m!==except){m.open=false;m.querySelector('summary')?.setAttribute('aria-expanded','false')}});
  const closeBranches=except=>{
    document.querySelectorAll('#NavDrawer .tb-brand-row__toggle[aria-expanded="true"]').forEach(b=>{if(b!==except)b.click()});
    document.querySelectorAll('#NavDrawer details[open]').forEach(d=>{if(d!==except)d.open=false});
  };
  const activate=m=>{
    closeMenus(m);closeDrawer(drawer('NavDrawer'));closeDrawer(drawer('CartDrawer'));
    m.open=true;m.querySelector('summary')?.setAttribute('aria-expanded','true');
  };
  document.addEventListener('pointerover',e=>{
    if(e.pointerType!=='mouse'||!matchMedia('(hover:hover)').matches)return;
    const m=e.target.closest('.tbmm-desktop-menu');
    if(m&&!m.contains(e.relatedTarget))activate(m);
    else if(e.target.closest('.tbmm-desktop-nav')&&!m)closeMenus();
  });
  document.addEventListener('pointerout',e=>{
    if(e.pointerType!=='mouse')return;
    const m=e.target.closest('.tbmm-desktop-menu');
    if(m&&!m.contains(e.relatedTarget)){m.open=false;m.querySelector('summary')?.setAttribute('aria-expanded','false')}
  });
  document.addEventListener('click',e=>{
    const m=e.target.closest('.tbmm-desktop-menu');
    const nav=e.target.closest('.js-drawer-open-nav');
    const cart=e.target.closest('.js-drawer-open-cart');
    const branch=e.target.closest('#NavDrawer .tb-brand-row__toggle');
    const care=e.target.closest('#NavDrawer details>summary');
    if(m){
      closeMenus(m);closeDrawer(drawer('NavDrawer'));closeDrawer(drawer('CartDrawer'));
      if(e.target.closest('summary')){e.preventDefault();if(e.detail===0&&m.open){m.open=false;m.querySelector('summary')?.setAttribute('aria-expanded','false')}else activate(m)}
    }
    if(nav||cart){closeMenus();closeDrawer(drawer(nav?'CartDrawer':'NavDrawer'))}
    if(branch)closeBranches(branch);
    if(care)closeBranches(care.parentElement);
    if(!m&&!e.target.closest('.tbmm-desktop-nav'))closeMenus();
    if(!nav&&!cart&&!e.target.closest('#NavDrawer,#CartDrawer,.js-drawer-close')){
      closeDrawer(drawer('NavDrawer'));closeDrawer(drawer('CartDrawer'));
    }
  },true);
  document.addEventListener('toggle',e=>{
    const m=e.target;
    if(m.matches?.('.tbmm-desktop-menu')){
      if(m.open)closeMenus(m);
      m.querySelector('summary')?.setAttribute('aria-expanded',String(m.open));
    }
  },true);
  document.addEventListener('keydown',e=>{
    if(e.key!=='Escape')return;
    const active=menus().find(m=>m.open);
    closeMenus();closeBranches();closeDrawer(drawer('NavDrawer'));closeDrawer(drawer('CartDrawer'));
    active?.querySelector('summary')?.focus();
  });
  const breakpoint=matchMedia('(min-width:990px)');
  breakpoint.addEventListener('change',()=>{closeMenus();closeBranches();closeDrawer(drawer('NavDrawer'));closeDrawer(drawer('CartDrawer'))});
  function terms(){
    const root=document.querySelector('.tb-info--terms-conditions .tb-info__article');
    if(!root||root.dataset.tbTermsFormatted)return;
    root.dataset.tbTermsFormatted='1';
    const before=root.textContent.replace(/\s+/g,'');
    const backup=root.cloneNode(true);
    let strong;
    while((strong=[...root.querySelectorAll('p strong')].find(s=>/^(OVERVIEW|SECTION\s+\d+\s*[-–])/i.test(s.textContent.trim())))){
      
      const p=strong.closest('p');
      if(!p||!root.contains(p))break;
      const leading=document.createRange();leading.selectNodeContents(p);leading.setEndBefore(strong);
      const trailing=document.createRange();trailing.selectNodeContents(p);trailing.setStartAfter(strong);
      const head=document.createElement('h2');head.append(...[...strong.childNodes].map(n=>n.cloneNode(true)));
      const first=p.cloneNode(false),last=p.cloneNode(false);
      first.append(leading.cloneContents());last.append(trailing.cloneContents());
      const nodes=[];
      if(first.textContent.trim()||first.querySelector('img,table'))nodes.push(first);
      nodes.push(head);
      if(last.textContent.trim()||last.querySelector('img,table'))nodes.push(last);
      p.replaceWith(...nodes);
    }
    if(root.textContent.replace(/\s+/g,'')!==before)root.replaceWith(backup);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',terms,{once:true});else terms();
  document.addEventListener('shopify:section:load',terms);
})();